<template>
  <div class="item t-tru">
    <h3 class="title">
      {{ data.title }}
      <span v-if="saoCungMenh">
        - {{ saoCungMenh.name }}
      </span>
    </h3>
    <div class="box">
      <div class="thap-than has-text-weight-bold" :class="data.can.class">
        {{ data.thapthan }}
      </div>
      <div class="vong-truong-sinh">
        {{ data.truongsinh }} <br/>
        <span v-if="data.truongSinhDong">({{ data.truongSinhDong }})</span>
      </div>
      <div class="thien-can" :class="data.can.class">
        {{ data.can.name }} <br/>
        <div>({{data.can.dovuong}})</div>
      </div>
      <div class="am-duong">{{ data.can.amduong }}</div>
      <div class="ngu-hanh">{{ data.can.nguhanh }}</div>
    </div>
    <div class="box-1">
      <div class="dia-chi" :class="data.chi.class">{{ data.chi.name }}</div>
      <div class="can-tang">
        <div
          v-for="(item, key) in data.chi.cantangchi"
          :key="key"
          class="can-tang-content"
        >
          <p :class="item.css">
            {{ item.tenCan }}
          </p>
          <p :class="item.css">
            {{ item.thapThan }}
          </p>
          <p :class="item.css">
            {{ item.truongSinh }} <br/>
            <span v-if="item.truongSinhDong">({{ item.truongSinhDong }})</span>
          </p>
          <p :class="item.css">
            ({{item.dovuong}})
          </p>
        </div>
      </div>
    </div>
    <div :class="`box-1 capitalize text-bold color_${data.nguhanhnapam.toLowerCase()}`">{{ data.napam.toLowerCase() }}</div>
    <item-than-sat
      :cattinh="data.cattinh"
      :hungtinh="data.hungtinh"
      :custom-height="customHeight"
    />
  </div>
</template>

<script>
import ItemThanSat from './ItemThanSat'
export default {
  name: 'ItemTru',
  components: {
    ItemThanSat
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    customHeight: {
      type: String,
      default: null
    },
    saoCungMenh: {
      type: [String, Object],
      default: null
    }
  }
}
</script>
